import React from 'react';
import { ReactComponent as Svg } from '../../svg/loader.svg';
import './Preloader.css';

const Preloader = ({ isInIntro }) => {
  return (
    <div id="preloader" className={isInIntro ? 'in-intro' : ''}>
      <Svg />
    </div>
  );
};

export default Preloader;
